import { withStyle } from 'baseui';
import { Block } from 'baseui/block';
import { Button, SIZE } from 'baseui/button';
import Alert from 'baseui/icon/alert';
import {Popover, StatefulPopover, TRIGGER_TYPE} from 'baseui/popover';
import { StyledTableBodyCell } from 'baseui/table-semantic';
import { Label1, Label2, Label4, ParagraphXSmall } from 'baseui/typography';
import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import ScenarioDataBuilder from '../../calculations/social/ScenarioBuilder';
import { formatter } from '../../calculations/SocialSecurityApi';
import { getMaritalStatus } from '../../calculations/userDataTransformer';

const WarningStyle = withStyle(StyledTableBodyCell, props => ({
    backgroundColor: props.$theme.colors.warning100,
}));

export const BreakevenTable = ({ answers, setJackAmount, setJillAmount, maritalStatus, mainTaking, spouseTaking }) => {
    const [hoverMain, setHoverMain] = React.useState(undefined);
    const [hoverMainWidowed, setHoverMainWidowed] = React.useState(undefined);
    const [hoverSurvivorsWidowed, setHoverSurvivorsWidowed] = React.useState(undefined);
    const [hoverMainSpousal, setHoverMainSpousal] = React.useState(undefined);
    const [hoverSpouse, setHoverSpouse] = React.useState(undefined);
    const [hoverSpouseSpousal, setHoverSpouseSpousal] = React.useState(undefined);

    const [choiceMain, setChoiceMain] = React.useState(undefined);
    const [choiceMainWidowed, setChoiceMainWidowed] = React.useState(undefined);
    const [choiceSurvivorWidowed, setChoiceSurvivorWidowed] = React.useState(undefined);
    const [choiceMainSpousal, setChoiceMainSpousal] = React.useState(undefined);
    const [choiceSpouse, setChoiceSpouse] = React.useState(undefined);
    const [choiceSpouseSpousal, setChoiceSpouseSpousal] = React.useState(undefined);
    const [spouseSpousalDisabled, setSpouseSpousalDisabled] = React.useState(false);
    const [mainSpousalDisabled, setMainSpousalDisabled] = React.useState(false);
    const [mainDisabled, setMainDisabled] = React.useState(false);
    const [spouseDisabled, setSpouseDisabled] = React.useState(false);
    const history = useHistory();


    React.useEffect(() => {
        if (mainTaking) {
            setJackAmount(3000 * 12)
        }
    }, [mainTaking, setJackAmount])


    const reset = () => {
        setChoiceMain(undefined);
        setChoiceMainSpousal(undefined);
        setChoiceSpouse(undefined);
        setChoiceSpouseSpousal(undefined);
        setSpouseSpousalDisabled(undefined);
        setMainSpousalDisabled(undefined);
        setMainDisabled(undefined);
        setSpouseDisabled(undefined);
        setChoiceMainWidowed(undefined);
        setChoiceSurvivorWidowed(undefined);
        setJackAmount(0)
        setJillAmount(0)
    }


    let scenarioBuilder = new ScenarioDataBuilder(answers);

    let yearWidth = 75;
    const borderRadius = 10;

    const setJack = (amt, index, type) => {
        setJackAmount(amt * 12);
        if (type === 'spousal') {
            setChoiceMainSpousal(index)
            setSpouseSpousalDisabled(true);
            setMainDisabled(true)
        } else {
            setChoiceMain(index)
            setMainSpousalDisabled(true);
        }
    }

    const setJill = (amt, index, type) => {
        setJillAmount(amt * 12);
        if (type === 'spousal') {
            setChoiceSpouseSpousal(index)
            setMainSpousalDisabled(true);
            setSpouseDisabled(true)
        } else {
            setChoiceSpouse(index)
            setSpouseSpousalDisabled(true);
        }
    }

    const setWidowedChoice = (amt, index, type) => {
        setJackAmount(amt * 12);
        if (type === 'survivors') {
            setChoiceSurvivorWidowed(index);
        } else {
            setChoiceMainWidowed(index)
        }
    }

    let bothTaking = (choiceMain || choiceMainSpousal) && (choiceSpouse || choiceSpouseSpousal);
    let anySelected = (choiceMain || choiceMainSpousal) || (choiceSpouse || choiceSpouseSpousal);

    const paintYears = (yearList, fn, startIndex, selectIndex, setClickIndex, type, otherAge, disabled, otherAgePicked, color, taking, otherName, something, widowed) => {

        return yearList.map((elem, index) => {
            if (elem.type === 'header') {
                return <th style={{ minWidth: yearWidth }}>
                    <Label1>
                        {selectIndex ? (type === 'spousal' ? "Spousal Benefit" : (widowed ? "Survivors Benefit: " : "Benefit: ")) : (widowed ? 'Survivors Benefit' : (type === 'spousal' ? "Spousal Benefit" : "Age Based Benefit: "))}
                    </Label1>
                    {type === 'spousal' ? <Label2>(% of {otherName}'s Age Based Benefit)</Label2> : undefined}
                </th>
            }

            if (elem.type === 'disabled') {
                return <th style={{ minWidth: yearWidth, height: 50 }}>
                    <StatefulPopover
                        content={() => <Label1>You can't choose your own spousal </Label1>}
                        triggerType={TRIGGER_TYPE.hover}
                        returnFocus
                        autoFocus
                    >

                        <Label1 color="lightgrey"> n / a</Label1>
                    </StatefulPopover>
                </th>
            }

            if (elem.type === 'not-chosen') {
                return <th style={{ minWidth: yearWidth, height: 50 }}>
                </th>
            }

            console.log(elem)
            return <th colSpan={'1'}
                onMouseEnter={() => {
                        fn(index);
                }} onClick={() => {
                    if (elem.amount !== 0) {
                        setClickIndex(elem.amount, index, type)
                    }
            }}
                style={{
                    backgroundColor: selectIndex && selectIndex <= index ? color : 'whitesmoke', border: '1px solid lightgrey',
                    borderBottomLeftRadius: selectIndex === index ? borderRadius : 0,
                    borderTopLeftRadius: selectIndex === index ? borderRadius : 0,
                    margin: 0, padding: 0,
                    minWidth: yearWidth, height: 50
                }}>
                <div style={{ minWidth: yearWidth, height: 50 }}>
                    {(elem.earningsTestReduction > 0 || elem.pensionReduction > 0) && !selectIndex ?
                        < WarningStyle >
                            <Popover isOpen={startIndex === index} content={() => (<Block padding={"20px"} $style={{ backgroundColor: 'warning200' }}>
                                You'll take a reduction here because you'll make too much money this year.
                                To avoid this, you'll need to retire earlier.
                                <br />
                                <ParagraphXSmall margin={0} padding={0}>{'$' + formatter.format(elem.raw) + ' base OR $' + formatter.format(elem.raw / 12) + '/mo'}</ParagraphXSmall>
                                <ParagraphXSmall margin={0} padding={0} color='negative400'>{'-$' + formatter.format(elem.pensionReduction) + ' (GPO)'}</ParagraphXSmall>
                                <ParagraphXSmall margin={0} padding={0} color='negative400'>{'-$' + formatter.format(elem.earningsTestReduction) + ' (Earnings Test)'}</ParagraphXSmall>
                                <ParagraphXSmall margin={0} padding={0} color='positive500'>{'$' + formatter.format(elem.amountYearly) + ' annually.'}</ParagraphXSmall>
                                <Button onClick={() => history.push('/app/income/employment')}>Show Me</Button>
                                <Button onClick={() => setClickIndex(elem.amount, index, type)}>Choose Anyways</Button>
                            </Block>)} returnFocus autoFocus>
                                <div style={{ width: '30px', display: 'flex' }}><Label4 $style={{ color: 'warning200' }}>{'$' + formatter.format(elem.amount)}</Label4>
                                    <Alert /></div>
                            </Popover>
                        </WarningStyle> :

                        <StatefulPopover
                            content={() => (
                                <div style={{ backgroundColor: 'whitesmoke', margin: 0, padding: 0 }}><ParagraphXSmall margin={0} padding={0}>{'$' + formatter.format(elem.amount * 12) + ' yearly'}</ParagraphXSmall>
                                    {/* <ParagraphXSmall margin={0} padding={0} color='negative400'>{'-$' + formatter.format(yearData.benefitBreakdown.wepReduction) + ' (GPO)'}</ParagraphXSmall>
                                <ParagraphXSmall margin={0} padding={0} color='positive500'>{'$' + formatter.format(yearData.benefitBreakdown.base - yearData.benefitBreakdown.wepReduction) + ' annually.'}</ParagraphXSmall> */}
                                </div>

                            )}
                            triggerType={TRIGGER_TYPE.hover}
                            returnFocus
                            autoFocus
                        >
                            <div>
                                {
                                    startIndex === index ? <Button size={SIZE.mini} onClick={(e) => console.log(e)}>{elem.age}</Button> : undefined
                                }
                                <Label4>
                                    {'$' + formatter.format(elem.amount)}
                                </Label4>
                            </div>
                        </StatefulPopover>}
                </div>
            </th >
        })
    }
    const headerStyling = (elem) => ({ border: '1px solid lightgrey', margin: 0, padding: 0, backgroundColor: elem === 'FRA' ? 'turquoise' : undefined });

    const MarriedPicker = () => {
        let mainData = scenarioBuilder.getMarriedMainScenarioData(
            choiceMain ? choiceMain - 1 : undefined,
            choiceMainSpousal ? choiceMainSpousal - 1 : undefined,
            choiceSpouseSpousal ? choiceSpouseSpousal - 1 : choiceSpouse ? choiceSpouse - 1 : undefined,
            choiceSpouse ? 'main' : choiceSpouseSpousal ? 'spousal' : undefined);

        let spouseData = scenarioBuilder.getMarriedSpouseScenarioData(choiceSpouse ? choiceSpouse - 1 : undefined,
            choiceSpouseSpousal ? choiceSpouseSpousal - 1 : undefined,
            choiceMainSpousal ? choiceMainSpousal - 1 : choiceMain ? choiceMain - 1 : undefined,
            choiceMain ? 'main' : choiceMainSpousal ? 'spousal' : undefined);

        const TotalHeading = () => {
            if (bothTaking) {
                return <tr>{scenarioBuilder.getTotalHeaders().map((elem, index) => {
                    let amount = (choiceSpouseSpousal ? spouseData[1][index].amount || 0 : spouseData[0][index].amount || 0) +
                        (choiceMainSpousal ? mainData[1][index].amount || 0 : mainData[0][index].amount || 0);

                    return <th style={{ border: '1px solid lightgrey', margin: 0, padding: 0, minWidth: yearWidth }}>
                        {index < 1 ? elem : formatter.format(amount)}
                    </th>
                })}
                </tr>
            } else {
                return <></>
            }
        }

        return <>
            <tr>{scenarioBuilder.getMainHeaders().map((elem) => <th style={headerStyling(elem)}>{elem}</th>)}</tr>

            {!choiceMainSpousal || !bothTaking ? <tr onMouseLeave={() => setHoverMain(undefined)}>
                {paintYears(mainData[0], setHoverMain, hoverMain, choiceMain, setJack, 'main', 62, mainDisabled, choiceSpouseSpousal, "#8884d8", mainTaking, mainTaking, 'Jill')}
            </tr> : undefined}
            {!mainTaking && (!choiceMain || !bothTaking) ? <tr onMouseLeave={() => setHoverMainSpousal(undefined)}>
                {paintYears(mainData[1], setHoverMainSpousal, hoverMainSpousal, choiceMainSpousal, setJack, 'spousal', 57, mainSpousalDisabled, choiceSpouse, "#8884d8", mainTaking, 'Jill')}
            </tr> : undefined}

            <tr>{scenarioBuilder.getSpouseHeaders().map((elem, index) => <th style={headerStyling(elem)}>{elem}</th>)}</tr>

            {!choiceSpouseSpousal || !bothTaking ? <tr onMouseLeave={() => setHoverSpouse(undefined)}>{paintYears(spouseData[0], setHoverSpouse, hoverSpouse, choiceSpouse, setJill, 'main', 62, spouseDisabled, choiceMainSpousal, "#a832a6", spouseTaking, spouseTaking, 'Jack')}</tr> : undefined}
            {!spouseTaking && (!choiceSpouse || !bothTaking) ? <tr onMouseLeave={() => setHoverSpouseSpousal(undefined)}>{paintYears(spouseData[1], setHoverSpouseSpousal, hoverSpouseSpousal, choiceSpouseSpousal, setJill, 'spousal', 62, spouseSpousalDisabled, choiceMain, "#a832a6", spouseTaking, 'Jack')}</tr> : undefined}
            <TotalHeading />
        </>
    }

    const DivorcedPicker = () => {
        let mainData = scenarioBuilder.getMarriedMainScenarioData(choiceMain ? choiceMain - 1 : undefined, choiceMainSpousal ? choiceMainSpousal - 1 : undefined, undefined, undefined);
        return <>
            <tr>{scenarioBuilder.getMainHeaders().map((elem) => <th style={headerStyling(elem)}>{elem}</th>)}</tr>
            {!choiceMainSpousal || !bothTaking ? <tr onMouseLeave={() => setHoverMain(undefined)}>{paintYears(mainData[0], setHoverMain, hoverMain, choiceMain, setJack, 'main', 62, mainDisabled, choiceSpouseSpousal, "#8884d8", mainTaking, mainTaking, 'Jill')}</tr> : undefined}
            {!mainTaking && (!choiceMain || !bothTaking) ? <tr onMouseLeave={() => setHoverMainSpousal(undefined)}>{paintYears(mainData[1], setHoverMainSpousal, hoverMainSpousal, choiceMainSpousal, setJack, 'spousal', 57, mainSpousalDisabled, choiceSpouse, "#8884d8", mainTaking, 'Jill')}</tr> : undefined}
        </>
    }


    const SinglePicker = () => {
        return <>
            <tr>{scenarioBuilder.getMainHeaders().map((elem) => <th style={headerStyling(elem)}>{elem}</th>)}</tr>
            <tr onMouseLeave={() => setHoverMain(undefined)}>
                {paintYears(scenarioBuilder.getSingleScenarioData(choiceMain - 1), setHoverMain, hoverMain, choiceMain, setJack, 'main', 62, mainDisabled, choiceSpouseSpousal, "#8884d8", mainTaking, mainTaking, 'Jill')}
            </tr>
        </>
    }

    const WidowedPicker = () => {
        let widowedScenarioData = scenarioBuilder.getWidowedScenarioData(choiceMainWidowed ? choiceMainWidowed - 1 : undefined, choiceSurvivorWidowed ? choiceSurvivorWidowed - 1 : undefined, undefined);

        return <>
            <tr>{scenarioBuilder.getMainHeaders().map((elem) => <th style={headerStyling(elem)}>{elem}</th>)}</tr>


            <tr onMouseLeave={() => setHoverSurvivorsWidowed(undefined)}>{paintYears(widowedScenarioData[0], setHoverSurvivorsWidowed, hoverSurvivorsWidowed, choiceSurvivorWidowed, setWidowedChoice, 'survivors', 62, false, choiceMainWidowed, "#82ca9d", mainTaking, mainTaking, 'Jill', true)}</tr>
            <tr onMouseLeave={() => setHoverMainWidowed(undefined)}>{paintYears(widowedScenarioData[1], setHoverMainWidowed, hoverMainWidowed, choiceMainWidowed, setWidowedChoice, 'mainwidowed', 62, false, choiceSurvivorWidowed, "#8884d8", mainTaking, mainTaking, 'Jill')}</tr>
        </>
    }

    return <>
        <table style={{ borderCollapse: 'collapse' }}>
            <tbody>
                {maritalStatus === 'married' ? <MarriedPicker /> : undefined}
                {maritalStatus === 'widowed' ? <WidowedPicker /> : undefined}
                {maritalStatus === 'divorced' ? <DivorcedPicker /> : undefined}
                {maritalStatus === 'never-married' ? <SinglePicker /> : undefined}
            </tbody>
        </table >

        {anySelected ||
            (maritalStatus === 'widowed' && choiceSurvivorWidowed || choiceMainWidowed) ||
            ((maritalStatus === 'divorced' && (choiceMain || choiceMainSpousal)) ||
                (maritalStatus === 'never-married' && choiceMain)) ? <Button onClick={(e) => reset()}>Start Over</Button> : undefined}
    </>
}


export default connect(state => ({
    answers: state.userData.answers,
    maritalStatus: getMaritalStatus(state.userData.answers),
    mainTaking: state.userData.answers.mainTaking,
    spouseTaking: state.userData.answers.spouseTaking,
}), {})(BreakevenTable);
